import React, { useEffect, useState } from 'react';
import { Button, Dialog, Form, Input, Table } from '@alifd/next';
import moment from 'moment';
import LzMsg from '@/components/common/LzMsg';
import LzPagination from '@/components/common/LzPagination';
import ExportBlack from './ExportBlack';
import styles from './index.module.scss';
import { Servlets } from '@/service/index';

const PrivateUserBlackList = () => {
  const [isLoading, setLoading] = useState(false);
  // form查询条件
  const [formSelectStatus, setFormSelectStatus] = useState({
    customerPin: '',
    recordType: '',
  });
  // 客服列表
  const [customerList, setCustomerList] = useState([]);
  // 用户列表
  const [UserBlackList, setUserBlackList] = useState([]);
  // 用户下单信息
  const [orderList, setOrderList] = useState([]);
  const [hasOrder, setHasOrder] = useState(false);

  // 是否确认移除黑名单二次确认弹窗相关
  const [removeItem, setRemoveItem] = useState(false);
  const [removePin, setRemovePin] = useState('');
  // 导入黑名单弹窗相关
  const [exportBlackFlag, setExportBlackFlag] = useState(false);

  // 批量解除黑名单，选中数组
  const [selectPins, setSelectPins] = useState([]);
  // 已选择个数
  const [chooseNum, setChooseNum] = useState(0);
  // 分页数据
  const [pageInfo, setPageInfo] = useState({
    pageNo: 1,
    pageSize: 10,
    total: 0,
  });
  /**
   * 翻页方法
   */
  const handlePageSizeChange = async (pages = {}) => {
    setLoading(true);
    try {
      getDyWaiterUserBlackList({ pageSize: pages.pageSize, pageNum: pages.pageNo });
    } catch (e) {
      setLoading(false);
      LzMsg.error(e.message);
    }
  };
  /**
   * 查询用户列表
   */
  const getDyWaiterUserBlackList = (v) => {
    setLoading(true);
    const params = {
      pageNum: pageInfo.pageNo,
      pageSize: pageInfo.pageSize,
      customerPin: formSelectStatus.customerPin,
      recordType: formSelectStatus.recordType,
      ...v,
    };
    Servlets('getDyWaiterUserBlackList', params).then((res) => {
      setUserBlackList(res.data);
      setPageInfo({
        ...pageInfo,
        pageNo: res.page.pageNo,
        pageSize: res.page.pageSize,
        total: res.page.total,
      });
      setLoading(false);
    });
  };

  /**
   * 重置筛选数据
   */
  const resetFilter = () => {
    setLoading(true);
    setFormSelectStatus({
      ...formSelectStatus,
      customerPin: '',
      recordType: '',
    });
    getDyWaiterUserBlackList({ pageNum: 1, pageSize: 10, customerPin: '', recordType: '' });
  };
  /**
   * 解除黑名单
   */
  const removeBlackList = (pin) => {
    Servlets('deleteDyBlackPin', { ids: pin }).then((res) => {
      if (res.data) {
        LzMsg.success('解除黑名单成功');
        setRemovePin('');
        // 已选则x项
        setChooseNum(0);
        // 刷新
        getDyWaiterUserBlackList({ pageNum: 1, pageSize: 10 });
        setRemoveItem(false);
        // searchUserBlackList({pageNum: 1});
      } else {
        LzMsg.error('解除黑名单失败，请稍后再试');
      }
    });
  };
  const removeSingleBlack = (pin) => {
    removeBlackList([pin]);
  };
  const removeMoreBlack = () => {
    if (selectPins.length >= 1) {
      removeBlackList(selectPins);
      setChooseNum(0);
    } else {
      LzMsg.warning('请先选择用户');
    }
  };
  useEffect(() => {
    getDyWaiterUserBlackList({ pageNum: 1, pageSize: 10 });
    // searchUserBlackList();
    // Service.getDyWaiterUserBlackList({ pageNum:1, pageSize:10}).then(res => {
    //   setUserBlackList(res.data);
    //   setPageInfo(res.page)
    // })
  }, []);
  useEffect(() => {
    getDyWaiterUserBlackList({ pageNum: pageInfo.pageNo, pageSize: pageInfo.pageSize });
  }, [exportBlackFlag]);
  const FormItem = Form.Item;
  // recordType 数据源
  const enterType = [
    { value: 1, label: '手动录入' },
    { value: 2, label: '文件上传' },
  ];
  return (
    <div>
      {/* <div className={styles.headerBox}>
        <div className={styles.headerText}>邀请专享客服用户</div>
      </div> */}
      <div className={`${styles['dedicated-waiter-user-list']}`}>
        {/* <div className={styles.listSearch}>
          <Form inline className={styles.listSearchForm} size="medium">
            <div style={{ width: '100%', display: 'flex' }}>
              <FormItem className={styles.formItem} label="用户手机号：">
                <Input
                  name="customerPin"
                  onChange={(value) => { setFormSelectStatus({ ...formSelectStatus, customerPin: value }) }}
                  value={formSelectStatus.customerPin}
                  style={{ width: '100%', borderRadius: '2px 2px 2px 2px' }} />
              </FormItem>
              <FormItem className={styles.formItem} label="黑名单来源:">
                <Select
                  name="recordType"
                  dataSource={enterType}
                  value={formSelectStatus.recordType}
                  onChange={(value) => { setFormSelectStatus({ ...formSelectStatus, recordType: value }) }}
                  style={{ width: '100%', borderRadius: '2px 2px 2px 2px' }} />
              </FormItem>

            </div>
            <div style={{ width: '100%', textAlign: 'right' }}>
              <FormItem className={styles.formItem}>
                <Button type="primary"
                  className={`${styles.submitBtnStyle_width} ${styles.submitBtnStyle_marginRight}`}
                  onClick={() => { setPageInfo({ ...pageInfo, pageNo: 1 }), getDyWaiterUserBlackList({ pageNum: 1 }) }}>查询</Button>

                <Button type="normal" className={`${styles.submitBtnStyle_width} ${styles.submitBtnStyle_marginRight}`} onClick={resetFilter}>重置</Button>
              </FormItem>
            </div>
          </Form>
        </div> */}


        <div className={styles.listSearch}>
          <Form inline className={styles.listSearchForm} size="medium" style={{ display: 'flex' }}>
            <FormItem label="用户手机号：" className={styles.formItem} style={{ flex: '1' }}>

              <Input
                name="customerPin"
                className={styles.formItem_width}
                placeholder="请输入..."
                maxLength={100}
                onChange={(value) => {
                  setFormSelectStatus({ ...formSelectStatus, customerPin: value });
                }}
                value={formSelectStatus.customerPin}
              />
            </FormItem>

            {/* <FormItem label="近30天下单数量：" className={styles.formItem}>
              <NumberPicker name="min" className={styles.formItem_width_NumberPicker} placeholder="最小..." max={1000000} min={0} />
              &emsp;-&emsp;
              <NumberPicker name="max" className={styles.formItem_width_NumberPicker} placeholder="最大..." max={1000000} min={0} />
            </FormItem> */}

            <FormItem label="" className={styles.formItem} style={{ flex: '1', textAlign: 'right' }}>
              <Form.Submit
                type="primary"
                onClick={() => {
                  setPageInfo({
                    ...pageInfo,
                    pageNo: 1,
                  }), getDyWaiterUserBlackList({ pageNum: 1 });
                }}
                className={`${styles.submitBtnStyle_width} ${styles.submitBtnStyle_marginRight}`}
              >查询
              </Form.Submit>

              <Form.Reset
                className={`${styles.submitBtnStyle_width} ${styles.submitBtnStyle_marginRight}`}
                onClick={resetFilter}
              >重置
              </Form.Reset>

            </FormItem>
          </Form>

        </div>


        <div className={`${styles['child-box']}`}>


          <div className={`${styles['search-list']}`} style={{ margin: '20px 0 15px 0' }}>
            <div style={{ flex: '1', marginTop: '13px' }}>
              <span>已选择<span style={{ color: '#FF3333' }}>&nbsp;{chooseNum}&nbsp;</span>项</span>
            </div>
            <Button
              type="primary"
              onClick={() => setExportBlackFlag(true)}
              style={{ marginRight: '10px' }}
            >批量导入营销黑名单
            </Button>
            <Button type="primary" onClick={removeMoreBlack}>批量解除营销黑名单</Button>
          </div>
          <Table
            loading={isLoading}
            dataSource={UserBlackList}
            rowSelection={{
              onChange: (value) => {
                // 改变选中list的值
                setSelectPins(value);
                // 选中的数量
                setChooseNum(value.length);
              },
            }}
            primaryKey="id"
          >
            <Table.Column title="用户手机号" dataIndex="customerPin" key="customerPin" />
            <Table.Column
              title="黑名单来源"
              key="recordType"
              cell={(value, index, item) => (
                item.recordType === 1 ? <span>手动录入</span> : <span>文件上传</span>
              )}
            />
            <Table.Column
              title="加入黑名单时间"
              key="createTime"
              cell={(value, index, item) => (
                <span>{moment(item.createTime).format('YYYY-MM-DD HH:mm:ss')}</span>
              )}
            />
            <Table.Column
              title="操作"
              key=" "
              cell={(value, index, item) => (
                <span
                  className={styles.globalLink}
                  style={{ color: '#5D4CFF' }}
                  onClick={() => {
                    setRemovePin(item.id), setRemoveItem(true);
                  }}
                >解除黑名单
                </span>
              )}
            />
          </Table>
          <LzPagination pageInfo={pageInfo} onChange={handlePageSizeChange} />
          {/* 移除黑名单二次确认弹窗 */}
        </div>


        <Dialog
          footer={false}
          style={{ width: '460px' }}
          shouldUpdatePosition
          visible={removeItem}
          onClose={() => {
            setRemovePin(''), setRemoveItem(false);
          }}
        >
          <div style={{ marginTop: '10px' }}>是否确认将所选用户移除黑名单？</div>
          <div style={{ textAlign: 'right', marginTop: '20px' }}>
            <Button
              type="normal"
              className={`cancel-btn ${styles.mr10}`}
              onClick={() => {
                setRemovePin(''), setRemoveItem(false);
              }}
            >取消
            </Button>
            <Button
              type="secondary"
              className={'submit-btn'}
              style={{ marginLeft: '10px' }}
              onClick={() => removeSingleBlack(removePin)}
            >确认
            </Button>
          </div>
        </Dialog>

        {/* 导入黑名单弹窗 exportBlackFlag */}
        <Dialog
          className="quickDialog_hjy"
          footer={false}
          shouldUpdatePosition
          title="黑名单批量导入"
          visible={exportBlackFlag}
          onClose={() => {
            setExportBlackFlag(false);
          }}
        >
          <ExportBlack cancel={() => {
            setExportBlackFlag(false);
          }}
          />
        </Dialog>

      </div>
    </div>
  );
};


export default PrivateUserBlackList;
